const notificationInbox = {
    margin: '0',
    minHeight: '100vh',
    display: 'grid',
    padding: '0.25rem 0 0',
};
const imageContainer = {
    top: '-1rem',
    position: 'relative',
};
const cardHeader = {
    width: '100%',
    display: 'flex',
    padding: {
        desktop: '40px 80px',
        mobile: '24px',
    },
};
const menuContainer = {
    width: '100%',
    padding: {
        desktop: '2.3rem 0 0',
        mobile: '0.75rem 0 0',
    },
};
const bottom = {
    display: 'flex',
    flexDirection: {
        desktop: 'row',
        mobile: 'column',
    },
    justifyContent: 'space-between',
    width: '100%',
    '& .MuiButton-root': {
        width: {
            desktop: '192px',
            mobile: '100%',
        },
    },
    '& .MuiTypography-root': {
        alignSelf: 'flex-end',
        margin: {
            desktop: '1rem 0',
            mobile: '1rem 0',
        },
    },
};
const emptyCard = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    justifyContent: 'center',
    height: '100%',
    paddingLeft: '48px',
    paddingRight: '48px',
    textAlign: 'center',
    '& .MuiButton-root': {
        alignSelf: 'center',
        width: {
            desktop: '180px',
            mobile: '100%',
        },
    },
};
const notificationCardWrapper = {
    display: 'flex',
    gap: {
        mobile: '16px',
        desktop: '24px',
    },
    flexDirection: 'column',
    padding: {
        mobile: '24px',
        desktop: '40px',
    },
    '& > .MuiTypography-root': {
        marginLeft: {
            mobile: '0',
            desktop: '42px',
        },
    },
};
const textMessage = {
    color: 'secondary.dark',
    lineHeight: '24px',
};
export default {
    notificationInbox,
    cardHeader,
    bottom,
    emptyCard,
    textMessage,
    menuContainer,
    notificationCardWrapper,
    imageContainer,
};
